import { createFileRoute } from "@tanstack/react-router";
import { Button, EmptyState } from "@sx/ui";
import { Icon } from "@sx/ui";

import { doorPrefix } from "../lib/doors";

export const Route = createFileRoute("/signed-out")({
  component: SignedOut,
});

/** A public, controlled terminal state for the Authentik invalidation flow. It deliberately
 * sits outside `_console`: mounting the session gate here would immediately begin a new OIDC
 * login and turn a successful logout back into a silent sign-in. */
function SignedOut() {
  const signIn = `${doorPrefix("auth")}/login`;

  return (
    <main className="grid h-full place-items-center p-6">
      <EmptyState
        icon={<Icon name="sign-out" tone="accent" />}
        title="You’re signed out"
        hint="Your sentientx and identity-provider sessions have ended on this browser."
        action={
          <Button asChild size="sm">
            <a href={signIn}>Sign in</a>
          </Button>
        }
      />
    </main>
  );
}
